// extracted by mini-css-extract-plugin
export default {"home":"Home_home__hjB5n","home__crumbs":"Home_home__crumbs__noXMY"};